/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSessionDTO
 */
export interface PaymentSessionDTO {
    /**
     * 
     * @type {string}
     * @memberof PaymentSessionDTO
     */
    sessionID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentSessionDTO
     */
    taxRateID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentSessionDTO
     */
    isoCountryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentSessionDTO
     */
    priceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaymentSessionDTO
     */
    redirectUrl?: string | null;
}

/**
 * Check if a given object implements the PaymentSessionDTO interface.
 */
export function instanceOfPaymentSessionDTO(value: object): value is PaymentSessionDTO {
    return true;
}

export function PaymentSessionDTOFromJSON(json: any): PaymentSessionDTO {
    return PaymentSessionDTOFromJSONTyped(json, false);
}

export function PaymentSessionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSessionDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionID': json['sessionID'] == null ? undefined : json['sessionID'],
        'taxRateID': json['taxRateID'] == null ? undefined : json['taxRateID'],
        'isoCountryCode': json['isoCountryCode'] == null ? undefined : json['isoCountryCode'],
        'priceId': json['priceId'] == null ? undefined : json['priceId'],
        'redirectUrl': json['redirectUrl'] == null ? undefined : json['redirectUrl'],
    };
}

export function PaymentSessionDTOToJSON(json: any): PaymentSessionDTO {
    return PaymentSessionDTOToJSONTyped(json, false);
}

export function PaymentSessionDTOToJSONTyped(value?: PaymentSessionDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionID': value['sessionID'],
        'taxRateID': value['taxRateID'],
        'isoCountryCode': value['isoCountryCode'],
        'priceId': value['priceId'],
        'redirectUrl': value['redirectUrl'],
    };
}

